const PREFIX = "bb_offline_";

export class PersistentCache
{
  public static read<T>( key: string ): T | null
  {
    try
    {
      const raw = localStorage.getItem( PREFIX + key );
      if ( !raw ) return null;
      return JSON.parse( raw ) as T;
    }
    catch
    {
      return null;
    }
  }

  public static write( key: string, value: unknown ): boolean
  {
    try
    {
      localStorage.setItem( PREFIX + key, JSON.stringify( value ) );
      return true;
    }
    catch ( e )
    {
      console.warn( `[OfflineCache] could not persist ${key}`, e );
      return false;
    }
  }

  public static remove( key: string ): void
  {
    try { localStorage.removeItem( PREFIX + key ); } catch {}
  }
}
